<template>
    <v-tooltip
        :disabled="!isOverflowing"
        max-width="1000"
        bottom
    >
        <template v-slot:activator="{ on }">
            <div
                v-on="on"
                ref="sidebarValue"
                class="sidebar-value"
            >
                <span>{{ value }}</span>
            </div>
        </template>
        <span>{{ value }}</span>
    </v-tooltip>
</template>

<script>
import {ref, onMounted} from "@vue/composition-api";

export default {
    name: "RawCustomField",
    props: {
        value: {
            type: String,
            required: true
        }
    },
    setup() {
        const sidebarValue = ref(null)
        const isOverflowing = ref(false)

        const checkOverflow = () => {
            isOverflowing.value = sidebarValue.value.scrollWidth > sidebarValue.value.clientWidth;
        };

        onMounted(() => {
            setTimeout(() => {
                checkOverflow()
            }, 100)
        });

        return {
            isOverflowing,
            sidebarValue,
        };
    }
}

</script>

<style scoped lang="scss">

</style>